import * as React from 'react';
import { useState } from 'react';
import { Button, ButtonSize, ButtonVariant, Sheet, YStack } from 'smoothie';

import IconSelection from '../steps/IconSelection';

interface EditIconSheetProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (icon: string) => void;
    selectedIcon: string;
}

const EditIconSheet = ({
    isOpen,
    onClose,
    onSubmit,
    selectedIcon,
}: EditIconSheetProps) => {
    const [icon, setIcon] = useState(selectedIcon);

    return (
        <Sheet isOpen={isOpen} onClose={onClose} title="Icon" showCloseButton>
            <YStack flex={1} alignItems="center" gap={20}>
                <IconSelection
                    selectedIcon={icon}
                    onSelect={(icon) => {
                        setIcon(icon);
                    }}
                />
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Save"
                    onPress={() => {
                        onSubmit(icon);
                    }}
                />
            </YStack>
        </Sheet>
    );
};

export default EditIconSheet;
